import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import AlertDialog from "../dialog/AlertDialog";
import ConfirmDialog from "../dialog/ConfirmDialog";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

export default function Layout({
  children,
  backdropStatus,

  alertDialogStatus,
  setAlertDialogStatus,
  alertDialogData,

  confirmDialogStatus,
  setConfirmDialogStatus,
  confirmDialogData,

  snackBarStatus,
  setSnackBarStatus,
  snackBarData,
}) {
  const classes = useStyles();

  const handleOnCloseAlertDialog = () => {
    setAlertDialogStatus(false);
    if (alertDialogData.onClose) {
      alertDialogData.onClose();
    }
  };

  const handleOnCloseConfirmDialog = () => {
    setConfirmDialogStatus(false);
    // if (confirmDialogData.onConfirm) {
    //   confirmDialogData.onConfirm(false);
    // }
  };

  const handleCloseSnackBar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarStatus(false);
  }

  return (
    <React.Fragment>
      <Backdrop className={classes.backdrop} open={backdropStatus}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <AlertDialog
        data={alertDialogData}
        open={alertDialogStatus}
        onClose={handleOnCloseAlertDialog}
      />
      <ConfirmDialog
        data={confirmDialogData}
        open={confirmDialogStatus}
        onClose={handleOnCloseConfirmDialog}
      />
      <Snackbar open={snackBarStatus} autoHideDuration={4000} onClose={handleCloseSnackBar} anchorOrigin={{ vertical: "bottom", horizontal: "left" }}>
        {snackBarData && snackBarData.mess && snackBarData.type && (
          <>
            {snackBarData.type === "success" && (
              <Alert severity="success" onClose={handleCloseSnackBar}>{snackBarData.mess}</Alert>
            )}
            {snackBarData.type === "warning" && (
              <Alert severity="warning" onClose={handleCloseSnackBar}>{snackBarData.mess}</Alert>
            )}
            {snackBarData.type === "error" && (
              <Alert severity="error" onClose={handleCloseSnackBar}>{snackBarData.mess}</Alert>
            )}
            {snackBarData.type === "info" && (
              <Alert severity="info" onClose={handleCloseSnackBar}>{snackBarData.mess}</Alert>
            )}
          </>
        )}
      </Snackbar>
      {children}
    </React.Fragment>
  );
}
